"use strict";
/// <reference path="./LanguagePicker.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguagePicker = exports.LanguagePickerMode = void 0;
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
const Cookies = require("js-cookie");
require("jquery-address");
const Utilities_1 = require("../../javascript/Utilities");
let $ = require("jquery");
var LanguagePickerMode;
(function (LanguagePickerMode) {
    LanguagePickerMode[LanguagePickerMode["ButtonBar"] = 1] = "ButtonBar";
    LanguagePickerMode[LanguagePickerMode["DropDown"] = 2] = "DropDown";
})(LanguagePickerMode = exports.LanguagePickerMode || (exports.LanguagePickerMode = {}));
class LanguagePicker {
    static init($elem, options) {
        return $elem.each(function () {
            let $this = $(this), synData = $this.data("synLanguagePicker");
            if (!synData) {
                $this.data("synLanguagePicker", $.extend({
                    dzvLanguageFtUrl: Utilities_1.synUtil.getWSUrl("ForeigntableEntries") + "dzvlanguage/",
                    iconUrl: Utilities_1.synUtil.getWSUrl("Icon"),
                    mode: LanguagePickerMode.ButtonBar,
                }, options));
                $this.trigger("beginInit");
                synData = $this.data("synLanguagePicker");
                $this.addClass("synLanguagePicker");
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: synData.dzvLanguageFtUrl,
                    done(languages) {
                        $this.html("");
                        synData.languages = languages;
                        // Sort languages: First deflang, then other languages by name/code
                        let defLang = Cookies.get("defLangId");
                        synData.languages.items.sort((a, b) => {
                            if (a.id === defLang) {
                                if (b.id === defLang)
                                    return 0;
                                return -1;
                            }
                            else {
                                if (b.id === defLang)
                                    return 1;
                                let prop = "name";
                                if (synData.mode === LanguagePickerMode.DropDown)
                                    prop = "code";
                                return a[prop] < b.prop ? -1 : a.prop === b.prop ? 0 : 1;
                            }
                        });
                        let hasIcon = typeof synData.languages.schema.ceimage !== "undefined";
                        if (synData.mode === LanguagePickerMode.ButtonBar) {
                            synData.$langControl = $this.addClass("langButtonBar");
                            $.each(synData.languages.items, (idx, lang) => {
                                let langButton = $("<button class='langButton btn' />")
                                    .attr("data-langid", lang.id)
                                    .on("click", function () {
                                    if (!$(this).hasClass("active")) {
                                        let langId = $(this).attr("data-langid");
                                        let found = $.grep(synData.languages.items, (e) => { return e.id === langId; });
                                        if (found.length) {
                                            let beforeEvt = $.Event("beforeLanguageChanged");
                                            $this.trigger(beforeEvt, [found[0]]);
                                            if (!beforeEvt.isDefaultPrevented()) {
                                                $this.children(".langButton").removeClass("active");
                                                $(this).addClass("active");
                                                $this.trigger("languageChanged", [found[0]]);
                                            }
                                        }
                                    }
                                })
                                    .appendTo($this);
                                langButton.append($("<span class='langText'>" + lang.code + "</span>"));
                                if (hasIcon)
                                    langButton.prepend($("<img class='langIcon' src='" + synData.iconUrl + "docid=" + lang.ceimage + "/24' />"));
                            });
                            if (synData.initialLangId != undefined)
                                $this.children(".langButton[data-langid='" + synData.initialLangId + "']").addClass("active");
                            else
                                $this.children(".langButton:first").addClass("active");
                        }
                        else {
                            synData.$langControl = $("<select class='synLanguageDropDown' />").appendTo($this);
                            let dropDownTemplate = hasIcon ?
                                "<span class='# if(data.disabled){#langDisabled#}#'><img src='" + synData.iconUrl + "docid=#:ceimage#/24' /><span style='margin-left:4px'>#:name#</span></span>"
                                : "<span>#:name#</span>";
                            synData.$langControl.kendoDropDownList({
                                dataTextField: "name",
                                dataValueField: "id",
                                template: dropDownTemplate,
                                valueTemplate: dropDownTemplate,
                                dataSource: { data: synData.languages.items },
                                dataBound(e) {
                                    let ddl = synData.$langControl.data("kendoDropDownList");
                                    if (synData.initialLangId != undefined) {
                                        ddl.select(function (item) {
                                            return item.id === synData.initialLangId;
                                        });
                                    }
                                    else
                                        ddl.select(0);
                                },
                                change(e) {
                                    let ddl = synData.$langControl.data("kendoDropDownList");
                                    let beforeEvt = $.Event("beforeLanguageChanged");
                                    let item = ddl.dataItem(ddl.select());
                                    $this.trigger(beforeEvt, [item]);
                                    if (!beforeEvt.isDefaultPrevented())
                                        $this.trigger("languageChanged", [item]);
                                },
                                select(e) {
                                    if (this.dataItem(e.item.index()).disabled)
                                        e.preventDefault();
                                }
                            }).data("kendoDropDownList");
                        }
                        $this.trigger("initSuccess");
                        $this.trigger("endInit");
                    }
                });
            }
        });
    }
    static destroy($elem) {
        return $elem.each(function () {
            let $this = $(this), synData = $this.data("synLanguagePicker");
            $(this).off("beginInit");
            $(this).off("initSuccess");
            $(this).off("endInit");
            $this.html("");
            $this.removeData("synLanguagePicker");
        });
    }
    // Enables/disables all langIds in langIds array (or all languages entirely if array is not passed), EXCEPT
    // the language currently selected
    static enableLangIds($elem, enable, langIds) {
        return $elem.each(function () {
            let $this = $(this), synData = $this.data("synLanguagePicker");
            if (synData.mode === LanguagePickerMode.ButtonBar) {
                $this.children(".langButton:not(.active)").each((idx, btn) => {
                    if (langIds == undefined || $.inArray($(btn).attr("data-langid"), langIds) >= 0) {
                        if (enable)
                            $(btn).removeAttr("disabled");
                        else
                            $(btn).attr("disabled", "disabled");
                    }
                });
            }
            else {
                let ddl = synData.$langControl.data("kendoDropDownList");
                let selectedIdx = ddl.select();
                let selectedId = ddl.dataItem(selectedIdx).id;
                $.each(synData.languages.items, (idx, lang) => {
                    if (selectedId !== lang.id && (langIds == undefined || $.inArray(lang.id, langIds) >= 0)) {
                        if (enable)
                            delete lang.disabled;
                        else
                            lang.disabled = true;
                    }
                });
                ddl.dataSource.data(synData.languages.items);
                ddl.select(selectedIdx);
            }
        });
    }
    // Changes selected language, IF that language is enabled.
    static setLanguage($elem, langId) {
        return $elem.each(function () {
            let $this = $(this), synData = $this.data("synLanguagePicker");
            if (synData.mode === LanguagePickerMode.ButtonBar)
                $this.children(".langButton[data-langid='" + langId + "']:not([disabled])").trigger("click");
            else {
                let ddl = synData.$langControl.data("kendoDropDownList");
                let oldIdx = ddl.select();
                ddl.select((item) => { return !item.disabled && item.id === langId; });
                if (oldIdx !== ddl.select())
                    ddl.trigger("change");
            }
        });
    }
    static getSelectedLanguage($elem) {
        const synData = $elem.data("synLanguagePicker");
        if (synData.mode === LanguagePickerMode.ButtonBar) {
            let langId = $elem.children(".langButton.active").attr("data-langid");
            return $.grep(synData.languages.items, (e) => { return e.id === langId; })[0];
        }
        else {
            let ddl = synData.$langControl.data("kendoDropDownList");
            return ddl.dataItem(ddl.select());
        }
    }
    static getLanguage($elem, langId) {
        const synData = $elem.data("synLanguagePicker");
        return $.grep(synData.languages.items, (e) => { return e.id === langId; })[0];
    }
}
exports.LanguagePicker = LanguagePicker;
// Dispatcher code
(($) => {
    $.fn.synLanguagePicker = function (method) {
        if (LanguagePicker[method])
            return LanguagePicker[method].apply(undefined, [this].concat(Array.prototype.slice.call(arguments, 1)));
        else if (typeof method === "object" || !method)
            return LanguagePicker.init(this, arguments[0]);
        else
            $.error("Method " + method + " does not exist on jQuery.synLanguagePicker");
    };
})(jQuery);
